import CheckIcon from '@mui/icons-material/Check'
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/RemoveCircleOutlineOutlined';
import { Typography } from '@mui/material'
import './daysLine.scss'

const getStatus = (value) => {
  if (value === 0) return 'success'
  if (value <= 10) return 'warning'
  return 'error'
}

const getIcon = (status, count) => {
  switch (status) {
    case 'success':
      return <CheckIcon fontSize="small" />
    case 'warning':
      return count
    case 'error':
      return count
    default:
      return null
  }
}

const DaysTimeline = ({ ranges }) => {
  return (
    <div className="trs-container">
      <div className="trs-track">
        {ranges.map(({ label, count }, i) => {
          const status = getStatus(count)
          return (
            <div key={i} className={`trs-circle trs-item trs-${status}`}>
              {getIcon(status, count)}
            </div>
          )
        })}
      </div>

      <div className="trs-labels">
        {ranges.map(({ label, count }, i) => {
          const status = getStatus(count)
          return (
            <Typography key={i} variant="body2" className={`trs-label trs-${status}`}>
              {label}
            </Typography>
          )
        })}
      </div>
    </div>
  )
}

export default DaysTimeline
